webpackJsonp([36,34],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _App = __webpack_require__(400);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _routes = __webpack_require__(290);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _router = __webpack_require__(124);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resetWinSize = function resetWinSize() {
	    BH_UTILS.setContentMinHeight($('main'), 'noHeader', 44);
	    $('body').niceScroll();
	};
	
	$(window).resize(resetWinSize);
	
	_router2.default.init(_routes2.default, {
	    beforeEach: function beforeEach(transition) {
	        $.bhPaperPileDialog.hide();
	        $('.jqx-window').each(function () {
	            $(this).jqxWindow('destroy');
	        });
	        transition.next();
	    },
	    afterEach: function afterEach(transition) {
	        resetWinSize();
	    }
	});
	
	window.__vue_router = _router2.default;
	
	_router2.default.start(_App2.default, '#app');

/***/ },

/***/ 108:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var STAFF_LIST = exports.STAFF_LIST = 'STAFF_LIST';
	var MENU_LIST = exports.MENU_LIST = 'MENU_LIST';
	var TREE_DATA = exports.TREE_DATA = 'TREE_DATA';

/***/ },

/***/ 124:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(79);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VueRouter = __webpack_require__(165);
	_vue2.default.use(VueRouter);
	
	window.Vue = _vue2.default;
	
	var router = new VueRouter();
	
	var _routes = null;
	
	var _setRoutes = function _setRoutes(routes) {
	    router.map(routes);
	    _routes = routes;
	};
	
	var _getRoutes = function _getRoutes() {
	    return _routes;
	};
	
	var _addSubRouter = function _addSubRouter(path, subRoutes, segments) {
	    router._addRoute(path, subRoutes, segments);
	};
	
	var _init = function _init(routes, callbacks) {
	    _setRoutes(routes);
	
	    if (callbacks) {
	        callbacks.beforeEach && router.beforeEach(callbacks.beforeEach);
	        callbacks.afterEach && router.afterEach(callbacks.afterEach);
	    }
	};
	
	var _start = function _start(comp, selector) {
	    router.start(comp, selector);
	};
	
	exports.default = {
	    init: _init,
	    start: _start,
	    getRoutes: _getRoutes,
	    setRoutes: _setRoutes,
	    addSubRouter: _addSubRouter
	};

/***/ },

/***/ 125:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchTreeData = exports.fetchMenus = exports.fetchStaffs = undefined;
	
	var _mutationTypes = __webpack_require__(108);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var fetchStaffs = exports.fetchStaffs = function fetchStaffs(_ref) {
	    var dispatch = _ref.dispatch,
	        state = _ref.state;
	
	    var staffs = ['Steven White', 'Nancy King', 'Nancy Davolio', 'Robert Davolio', 'Michael Leverling', 'Andrew Callahan', 'Michael Suyama', 'Anne King', 'Laura Peacock', 'Robert Fuller', 'Janet White', 'Nancy Leverling', 'Robert Buchanan', 'Margaret Buchanan', 'Andrew Fuller', 'Anne Davolio', 'Andrew Suyama', 'Nige Buchanan', 'Laura Fuller'];
	
	    setTimeout(function () {
	        dispatch(types.STAFF_LIST, staffs);
	    }, 3000);
	};
	
	var fetchMenus = exports.fetchMenus = function fetchMenus(_ref2) {
	    var dispatch = _ref2.dispatch,
	        state = _ref2.state;
	
	    var menus = {
	        title: '组件列表',
	        iconFont: '',
	        data: [[{
	            'text': '输入框组',
	            'icon': 'iconfont icon-bookmark',
	            'href': '#!/',
	            'active': true }, {
	            'text': '卡片',
	            'icon': 'iconfont icon-menu',
	            'href': '#!/card'
	        }, {
	            'text': '面板',
	            'icon': 'iconfont icon-menu',
	            'href': '#!/panel'
	        }, {
	            'text': '下拉框',
	            'icon': 'iconfont icon-menu',
	            'href': '#!/dropdown'
	        }, {
	            'text': '步骤向导',
	            'icon': 'iconfont icon-menu',
	            'href': '#!/stepwizard'
	        }, {
	            'text': '竖向步骤条',
	            'icon': 'iconfont icon-menu',
	            'href': '#!/stepflow'
	        }, {
	            'text': '列表选择器',
	            'icon': 'iconfont icon-menu',
	            'href': '#!/choose'
	        }, {
	            'text': '表格[jqwidgets]',
	            'icon': 'iconfont icon-tablet',
	            'href': '#!/datatable'
	        }, {
	            'text': '表格[EMAP]',
	            'icon': 'iconfont icon-tablet',
	            'href': '#!/emap-datatable'
	        }, {
	            'text': '高级表格[EMAP Grid]',
	            'icon': 'iconfont icon-tablet',
	            'href': '#!/emap-grid'
	        }, {
	            'text': '普通多条件搜索[EMAP]',
	            'icon': 'iconfont icon-tablet',
	            'href': '#!/emap-search'
	        }, {
	            'text': '高级搜索[EMAP]',
	            'icon': 'iconfont icon-tablet',
	            'href': '#!/emap-search-adv'
	        }, {
	            'text': '卡片列表[EMAP]',
	            'icon': 'iconfont icon-tablet',
	            'href': '#!/emap-card'
	        }, {
	            'text': '表单[EMAP]',
	            'icon': 'iconfont icon-tablet',
	            'href': '#!/emap-form'
	        }, {
	            'text': '下拉表格[EMAP]',
	            'icon': 'iconfont icon-tablet',
	            'href': '#!/emap-dd-table'
	        }, {
	            'text': '下拉树[EMAP]',
	            'icon': 'iconfont icon-tablet',
	            'href': '#!/emap-dd-tree'
	        }, {
	            'text': '级联下拉[EMAP]',
	            'icon': 'iconfont icon-tablet',
	            'href': '#!/emap-linkage'
	        }, {
	            'text': '日历',
	            'icon': 'iconfont icon-tablet',
	            'href': '#!/calendar'
	        }, {
	            'text': '表格导入',
	            'icon': 'iconfont icon-tablet',
	            'href': '#!/excelupload'
	        }, {
	            'text': '文件上传',
	            'icon': 'iconfont icon-tablet',
	            'href': '#!/fileupload'
	        }, {
	            'text': '图片上传',
	            'icon': 'iconfont icon-tablet',
	            'href': '#!/imageupload'
	        }, {
	            'text': '头像裁剪上传',
	            'icon': 'iconfont icon-tablet',
	            'href': '#!/avatarupload'
	        }, {
	            'text': '加载效果',
	            'icon': 'iconfont icon-filter',
	            'href': '#!/loading'
	        }, {
	            'text': '工具提示',
	            'icon': 'iconfont icon-settings',
	            'href': '#!/tooltip'
	        }, {
	            'text': '气泡弹窗',
	            'icon': 'iconfont icon-settings',
	            'href': '#!/popover'
	        }, {
	            'text': '模态对话框',
	            'icon': 'iconfont icon-settings',
	            'href': '#!/window'
	        }, {
	            'text': '树形控件',
	            'icon': 'iconfont icon-settings',
	            'href': '#!/tree'
	        }, {
	            'text': 'Tab控件',
	            'icon': 'iconfont icon-settings',
	            'href': '#!/tab'
	        }, {
	            'text': '导航菜单',
	            'icon': 'iconfont icon-settings',
	            'href': '#!/nav'
	        }, {
	            'text': '分页',
	            'icon': 'iconfont icon-settings',
	            'href': '#!/pagination'
	        }, {
	            'text': '富文本编辑器',
	            'icon': 'iconfont icon-settings',
	            'href': '#!/editor'
	        }]]
	    };
	
	    dispatch(types.MENU_LIST, menus);
	};
	
	var fetchTreeData = exports.fetchTreeData = function fetchTreeData(_ref3) {
	    var dispatch = _ref3.dispatch,
	        state = _ref3.state;
	
	    var data = [{ "id": "4d5ba82a-c251-4e04-9b12-627e38d8a4b4", "label": "晓庄学院-学生组", "parentId": "125950196096958464", "description": "", "dynamic": true, "userCount": 0, "inType": 10, "leaf": true, "expanded": false, "selected": false }, { "id": "3b7edcf0-01ec-4fe3-bd26-6dcbe55db13b", "label": "晓庄学院-老师组", "parentId": "125950196096958464", "description": "", "dynamic": true, "userCount": 0, "inType": 10, "leaf": true, "expanded": false, "selected": false }, { "id": "f750354d-bea8-436b-a78a-684970c3dd09", "label": "应用测试", "parentId": "125950196096958464", "description": "", "dynamic": false, "userCount": 0, "inType": 10, "leaf": true, "expanded": false, "selected": false }];
	
	    dispatch(types.TREE_DATA, data);
	};

/***/ },

/***/ 126:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var staffList = exports.staffList = function staffList(state) {
	  return state.staffs;
	};
	var menuList = exports.menuList = function menuList(state) {
	  return state.menus.all;
	};
	var treeData = exports.treeData = function treeData(state) {
	  return state.tree.all;
	};

/***/ },

/***/ 127:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(79);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(164);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _menus = __webpack_require__(294);
	
	var _menus2 = _interopRequireDefault(_menus);
	
	var _tree = __webpack_require__(295);
	
	var _tree2 = _interopRequireDefault(_tree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	_vue2.default.config.debug = true;
	
	var debug = ("production") !== 'production';
	
	exports.default = new _vuex2.default.Store({
	    modules: {
	        menus: _menus2.default,
	        tree: _tree2.default
	    },
	    strict: debug
	});

/***/ },

/***/ 228:
/***/ function(module, exports) {

	module.exports = " <bh-header logo=http://res.wisedu.com/scenes/public/images/demo/logo.png slogon=\"jqwidget-based Vue Components\" :has-sidemenu=true :nav-items=navItems :side-menus=sideMenus :icons=icons :user-info=userInfo> </bh-header> <main> <router-view></router-view> </main> <bh-footer copyright=\"版权信息：© 2015 江苏金智教育信息股份有限公司 苏ICP备10204514号\"></bh-footer> <div id=message_success></div> <div id=message_error></div> <div id=jqxLoader style=display:none></div> ";

/***/ },

/***/ 272:
/***/ function(module, exports) {

	module.exports = "<code> <pre>\r\n<template>\r\n    <div class=\"bh-mv-8 bh-row\">\r\n        <div class=bh-col-md-2>\r\n            <div style=\"width: 400px\">\r\n                <bh-nav :source=navMenus @trigger=navClick></bh-nav>\r\n            </div>\r\n        </div>\r\n        <div class=bh-col-md-10>\r\n            <router-view></router-view>\r\n        </div>\r\n    </div>\r\n</template>\r\n\r\n<script>\r\n    import router from 'src/router'\r\n    import BhCard from 'components/bh-card/bhCard'\r\n    import BhNav from 'components/bh-nav/bhNav'\r\n\r\n    export default {\r\n        data: function() {\r\n            return {\r\n                navMenus: [\r\n                    {id: 1, name: '首页应用', icon: 'iconfont icon-home', type: 'link', url: '/nav', active: true},\r\n                    {id: 8, name: '消息', icon: 'icon-envelope', type: 'link', url: '/nav/demo/msg'},\r\n                    {id: 2, name: '云端中心', icon: 'iconfont icon-cloud', expand: false, children: [\r\n                        {id: 21, name: '收到的消息', type: 'link', url: '/nav/demo/cloud/receive'},\r\n                        {id: 22, name: '发出的消息', type: 'link', url: '/nav/demo/cloud/send'},\r\n                        {id: 23, name: '收藏的消息', type: 'link', url: '/nav/demo/cloud/favorite'},\r\n                    ]},\r\n                    {id: 3, name: '运营数据中心', icon: 'icon-moon', expand: false, children: [\r\n                        {id: 31, name: '收到的消息', type: 'link', url: '/nav/demo/data/receive'},\r\n                        {id: 32, name: '发出的消息', type: 'link', url: '/nav/demo/data/send'},\r\n                        {id: 33, name: '收藏的消息', type: 'link', url: '/nav/demo/data/favorite'},\r\n                    ]},\r\n                    {id: 4, name: '打印模板', icon: 'iconfont icon-print', type: 'trigger'},\r\n                    {id: 5, name: '权限管理', icon: 'iconfont icon-lock', type: 'trigger'},\r\n                    {id: 6, name: '用户角色', icon: 'icon-user', type: 'trigger'},\r\n                    {id: 7, name: '帮助与支持', icon: 'icon-question-sign', type: 'trigger'}\r\n                ]\r\n            }\r\n        },\r\n        methods: {\r\n            navClick: function(item) {\r\n                console.log(item.name + \" selected!\");\r\n            }\r\n        },\r\n        components: {BhCard, BhNav}\r\n    }\r\n</script>\r\n    </pre> </code> ";

/***/ },

/***/ 290:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '/': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(402)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/wrapper': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(27, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(433)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        },
	        subRoutes: {
	            '/plugin/:id': {
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(129)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            }
	        }
	    },
	    '/plugin/:id': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(129)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    '/card': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(26, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(404)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/panel': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(424)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/dropdown': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(408)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/choose': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(405)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/stepwizard': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(428)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/stepflow': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(427)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/datatable': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(406)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/calendar': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(403)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/excelupload': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(416)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/fileupload': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(24, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(417)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/imageupload': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(25, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(418)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/avatarupload': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(23, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(401)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/emap-datatable': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(407)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/emap-card': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(28, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(410)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/emap-grid': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(414)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/emap-search': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(22, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(425)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/emap-search-adv': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(21, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(426)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/emap-form': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(413)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/emap-dd-table': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(30, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(411)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/emap-dd-tree': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(29, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(412)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/emap-linkage': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(31, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(415)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/loading': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(419)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/tooltip': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(430)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/window': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(432)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/tree': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(20, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(431)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/tab': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(429)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/pagination': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(423)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/editor': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(409)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/nav': {
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(33, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(422)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        },
	        subRoutes: {
	            '/': {
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(420)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                },
	                subRoutes: {
	                    '/': {
	                        component: {
	                            template: '<p>云端中心-收到的消息</p>'
	                        }
	                    },
	                    '/cloud/receive': {
	                        component: {
	                            template: '<p>云端中心-收到的消息</p>'
	                        }
	                    },
	                    '/cloud/send': {
	                        component: {
	                            template: '<p>云端中心-发出的消息</p>'
	                        }
	                    },
	                    '/cloud/favorite': {
	                        component: {
	                            template: '<p>云端中心-收藏的消息</p>'
	                        }
	                    },
	                    '/data/receive': {
	                        component: {
	                            template: '<p>运营数据中心-收到的消息</p>'
	                        }
	                    },
	                    '/data/send': {
	                        component: {
	                            template: '<p>运营数据中心-发出的消息</p>'
	                        }
	                    },
	                    '/data/favorite': {
	                        component: {
	                            template: '<p>运营数据中心-收藏的消息</p>'
	                        }
	                    },
	                    '/print': {
	                        component: {
	                            template: '<p>打印模板</p>'
	                        }
	                    },
	                    '/msg': {
	                        component: {
	                            template: '<p>消息页面</p>'
	                        }
	                    }
	                }
	            },
	            '/source': {
	                component: {
	                    template: __webpack_require__(272)
	                }
	            },
	            '/doc': {
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(32, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(421)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            }
	        }
	    }
	};

/***/ },

/***/ 291:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(79);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.directive('bh-tooltip', function (val) {
	    var el = $(this.el);
	
	    el.jqxTooltip(val);
	});

/***/ },

/***/ 292:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(79);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.directive('bh-validate', {
	    bind: function bind() {
	        console.log('binded');
	        console.log(this);
	    },
	    update: function update(value) {
	        console.log('updated');
	        console.log(this);
	    },
	    unbind: function unbind() {
	        console.log('updated');
	    }
	});

/***/ },

/***/ 293:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Vue = __webpack_require__(79);
	
	Vue.filter('defaultDate', {
	    read: function read(val) {
	        return val || new Date();
	    },
	    write: function write(val, oldVal, format) {
	        return moment(val).format(format);
	    }
	});

/***/ },

/***/ 294:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(123);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	    'all': {}
	};
	
	var mutations = (0, _defineProperty3.default)({}, _mutationTypes.MENU_LIST, function (state, menus) {
	    state.all = menus;
	});
	
	exports.default = {
	    state: state,
	    mutations: mutations
	};

/***/ },

/***/ 295:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(123);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	    all: []
	};
	
	var mutations = (0, _defineProperty3.default)({}, _mutationTypes.TREE_DATA, function (state, data) {
	    state.all = data;
	});
	
	exports.default = {
	    state: state,
	    mutations: mutations
	};

/***/ },

/***/ 331:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bhHeader = __webpack_require__(373);
	
	var _bhHeader2 = _interopRequireDefault(_bhHeader);
	
	var _bhFooter = __webpack_require__(372);
	
	var _bhFooter2 = _interopRequireDefault(_bhFooter);
	
	var _store = __webpack_require__(127);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _action = __webpack_require__(125);
	
	var _getters = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(292);
	__webpack_require__(291);
	__webpack_require__(293);
	
	exports.default = {
	    data: function data() {
	        return {
	            'icons': [{ 'className': 'icon-apps', 'attrs': { 'id': 'iconApps', 'data-flag': true } }, { 'className': 'icon-settings' }],
	            'navItems': [{
	                'title': '组件',
	                'hide': false,
	                'active': true,
	                'className': 'firstFlag',
	                'href': '#!/',
	                'isOpenNewPage': false }, {
	                'title': '第三方应用',
	                'hide': false,
	                'active': false,
	                'className': 'secondFlag',
	                'href': '#!/wrapper',
	                'isOpenNewPage': false }, {
	                'title': 'API文档',
	                'hide': false,
	                'active': false,
	                'href': 'http://res.wisedu.com/FS/vue-doc/',
	                'isOpenNewPage': true }],
	            'userInfo': {
	                'image': 'http://res.wisedu.com/scenes/public/images/demo/user1.png',
	                'info': ['游客', '01115089'],
	                'logoutHref': '#'
	            }
	        };
	    },
	
	    store: _store2.default,
	    vuex: {
	        actions: {
	            fetchMenus: _action.fetchMenus
	        },
	        getters: {
	            sideMenus: _getters.menuList
	        }
	    },
	    ready: function ready() {
	        this.fetchMenus();
	        console.log('setContentMinHeight');
	    },
	
	    components: { BhHeader: _bhHeader2.default, BhFooter: _bhFooter2.default }
	};

/***/ },

/***/ 400:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(331)
	__vue_template__ = __webpack_require__(228)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }

});


// WEBPACK FOOTER //
// js/app.f0756ea1e9deca1bb726.js